import type { QuotaPolicy } from '@cca/xero-shared';

// A sensible starting policy for the "new policy" / what-if forms — mirrors the
// worked example in quota-test-vectors.json (spec §7). Rates are FRACTIONS
// (0.05 = 5%); the form shows them as percentages. The diocese ratifies the
// real numbers; this is just a non-empty scaffold so the registrar isn't
// staring at zeroes.
export function defaultPolicy(assessmentYear: number): QuotaPolicy {
  return {
    policy_version: '',
    effective_assessment_year: assessmentYear,
    income_base: { source_field: 'total_gross_income', apply_exclusions: true },
    category_exclusion: {},
    base_exclusion: 0,
    smoothing: { method: 'rolling_average', years: 3, min_years_required: 1, basis_year: null },
    bands: [
      { from: 0, rate: 0.0 },
      { from: 50_000, rate: 0.05 },
      { from: 150_000, rate: 0.075 },
      { from: 400_000, rate: 0.1 },
    ],
    // Phase-in defaults OFF in the public calculator (Steve, 2026-07-02); the
    // schedule stays as a scaffold for when someone ticks it on.
    phase_in: { enabled: false, schedule: [0.5, 0.75, 1.0] },
    floor: 500,
    cap: { cap_amount: null, cap_pct_of_assessable: null },
    yoy_increase_cap: null,
    yoy_base_year: new Date().getFullYear(),
    collar: false,
    // Quotas always round to the nearest $10 (no longer registrar-configurable).
    rounding: { to: 10, mode: 'half_up' },
  };
}
